


































































import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import { DirectiveOptions } from 'vue';
import * as clickOutside from 'vue-click-outside';
import FocusLoop from '@vue-a11y/focus-loop/src/FocusLoop.vue';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useAppScrollLock } from '@front-app/hooks/useScrollLock';
import SimpleCard from '../cards/SimpleCard.vue';
import { Spacing } from '../constants';

export default defineComponent({
	components: {
		FocusLoop,
		IconButton,
		FontAwesomeIcon,
		SimpleCard,
	},
	directives: {
		clickOutside: clickOutside as DirectiveOptions,
	},
	props: {
		isOpen: Boolean,
		fitContent: Boolean,
		modalClass: {
			type: String,
			default: '',
		},
		contentClass: {
			type: String,
			default: '',
		},
		closeButtonAriaLabel: {
			type: String,
			required: true,
		},
		ariaLabelledby: {
			type: String,
			required: true,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.EXTRA_LOOSE,
		},
	},
	setup(props, ctx) {
		const appScrollLock = useAppScrollLock();
		watch(computed(() => props.isOpen), (isOpen) => {
			if (isOpen) {
				appScrollLock.register();
			} else {
				appScrollLock.unregister();
			}
		});
		const hasSlotChildren = computed(() => {
			const defaultSlot = ctx.slots.default;
			return defaultSlot && defaultSlot().length > 0;
		});
		return {
			hasSlotChildren,
		};
	},
});
